import {
  call, takeLatest, put, select,
} from 'redux-saga/effects';
import apiFetchEdiRfidAuditExecutionDelete from '../../api/EdiRfidAuditExecutionDeleteAPI';
import { EDI_RFID_AUDIT_EXECUTION_DELETE_REQUEST } from '../actions/types/EdiRfidAuditExecutionDeleteActionsTypes';
import { deleteEdiRfidAuditExecutionSuccessActionCreator, deleteEdiRfidAuditExecutionFailureActionCreator } from '../actions/EdiRfidAuditExecutionDeleteActions';
import { showNotification } from '../../../../../../common/redux/actions/NotificationActions';
import { formatMessage } from '../../../../../../../locales/locales';
import { languageSelector } from '../../../../../../common/redux/selectors/languageSelector';

function* doEdiRfidAuditExecutionDeleteWorker(action) {
  const lang = yield select(languageSelector);
  try {
    const res = yield call(apiFetchEdiRfidAuditExecutionDelete, action.payload);
    yield put(deleteEdiRfidAuditExecutionSuccessActionCreator(res.data));
    yield put(showNotification({
      type: 'SUCCESS',
      message: formatMessage(lang, 'notification.edirfidauditexecution.delete.success'),
    }));
  } catch (error) {
    yield put(deleteEdiRfidAuditExecutionFailureActionCreator(error));
    yield put(showNotification({
      type: 'ERROR',
      message: formatMessage(lang, 'notification.edirfidauditexecution.delete.failure'),
    }));
  }
}

function* doEdiRfidAuditExecutionDeleteWatcher() {
  yield takeLatest(EDI_RFID_AUDIT_EXECUTION_DELETE_REQUEST, doEdiRfidAuditExecutionDeleteWorker);
}

export default doEdiRfidAuditExecutionDeleteWatcher;
